const accessMgmtAPIBase = '/v1/sft_config/access_mgt';
export const fxgBaseApi = '/authorizations/v1/fxg';

const paths = {
  home: '/home',
  routes: {

  },
  apiPaths: {
    saveUserPreferenceData: `${accessMgmtAPIBase}/preference_data/user/save`,
    fxgSaveUserPreferenceData: `${fxgBaseApi}/preference-data/user/save`,
  },
};

export default paths;
